import React, { Component } from 'react';
import Axios from 'axios';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { connect } from 'react-redux';
import { addToCart } from '../redux/Action'
import { API_URL } from '../API_url/API_URL';
import { Table } from 'reactstrap';
import { Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';


class Cart extends Component {
    state = {
        data: [],
        date: new Date().toLocaleDateString(),
        detail: [],
        redirectHome: false
    }

    componentDidMount(){
        // id ambildari global state
        // connect react-redux
        // let id = localStorage.getItem('username')
        let { idUser } = this.props
        Axios.get(API_URL+ `/users/${idUser}`)
        .then((res) => {
            this.setState({data: res.data.cart})
            console.log(this.state.data)
        })
        .catch((err) =>{
            console.log(err)
        })
    }

    renderCart = () => {
        //map isi this.state.data
        // map jadi tablerow=== reacstrap
        // let { data } = this.state
        console.log(this.state.data)

        return this.state.data.map((val, index) => {
            if(val.ticketAmount === 0){
                return null
            }else{ 
                return (
                    <tr>
                        <td>{index+1}</td>
                        <td>{val.name}</td>
                        <td>{this.renderNum(val.seats)}</td>
                        <td>{val.ticketAmount}</td>
                        <td>Rp. {val.totalPrice}</td>
                        <td>
                            <Button onClick={this.deleteCart(index)}>Delete</Button>
                        </td>
                    </tr>            
                )
            }
        })

    }

    deleteCart = (index) => {
        let { idUSer } = this.props
        Axios.delete(API_URL+ `/users?id=${idUSer}&cart[${index}]`)
        .then((res) => {
            Axios.delete(API_URL+ '/movies?booked')
            console.log(res.data)
            .then((res) => {
                console.log(res.data)
                Axios.get(API_URL+ '/movies')
            })
                .then((res) => {
                    console.log(res.data)
                    this.setState({data: res.data})
                    alert('Delete cart successful')
            })
        })
        .catch((err) =>{
            console.log(err)
        })
    }

    totalAmount = () => {
        let output = 0
        this.state.data.map((val) => {
            return output += val.ticketAmount
        })
        return output
    }
    
    totalPrice = () => {
        let output = 0
        this.state.data.map((val) => {
            return output += val.totalPrice
        })
        return output
    }


    renderNum = (arr) => {
        let alpha = 'ABCDE'
        let arr2 = ''
        let out = []
        let output = []
        console.log(arr)
        for(var i =0; i<arr.length; i++){
            arr2 = parseInt(arr[i][1])+1
            out = (alpha[arr[i][0]] +arr2) + '; '
            output.push(out)
            
        }
        return output
    }

    checkOut = () => {
       let { date, detail } = this.state
       let { idUser, cart } = this.props
       let d = new Date()
       let hours = d.getHours() + ':' +d.getMinutes()
       date = hours + ' - ' + date
       let totalPrice = this.totalPrice()
       let totalAmount = this.totalAmount()

       console.log(detail)
       console.log(idUser)

       Axios.post(API_URL + `/transactions`, {
           idUser,
           date,
           totalAmount,
           totalPrice,
           detail: cart
       })
       .then((res) => {
            console.log(res.data)
            Axios.patch(API_URL+`/users/${idUser}`, {
                cart: []
        })
            .then((res) => {
                console.log(res.data)
                })
            // .catch((err) => {
            //     console.log(err)
            // })
        })
        .catch((err) => {
            console.log(err)
        })
        if(idUser){
            this.setState({ redirectHome: true})
        }   
    }


    render() {
        console.log(this.props.idUser)
        // let { username } = this.props
        let { redirectHome } = this.state
        if(redirectHome){
            return(
                <Redirect to='/' />
            )
        }
        return (
            <div>
                <Table>
                <thead color="primary-color" textWhite>
                    <tr>
                    <th>Id</th>
                    <th>Movie Title</th>
                    <th>seats</th>
                    <th>Amount</th>
                    <th>Total Price</th>
                    <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderCart()}
                    <tr>
                        <th>#</th>
                        <th>Total </th>
                        <th> </th>
                        <th>{this.totalAmount()}</th>
                        <th>Rp. {this.totalPrice().toLocaleString()}</th>

                    </tr>
                </tbody>
                </Table>
                    <div>
                        <Button variant="contained" color='primary' onClick={this.checkOut}>
                            <ShoppingCartIcon></ShoppingCartIcon>
                            Check Out</Button>
                    </div>        
                </div>
        )
    }
}

const mapStatetoProps = ({auth}) => {
    return {
        idUser: auth.id,
        cart: auth.cart,
        username: auth.username
    }
}
 
export default connect(mapStatetoProps, { addToCart })(Cart);